import React, { useState, cloneElement } from 'react'
import PropTypes from 'prop-types'

import { ClickAwayListener, Tooltip } from '@material-ui/core'
import { TooltipProps } from '@material-ui/core/Tooltip/Tooltip'

function GofindTooltip(props) {
  const { title, children } = props
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const handleTooltipToggle = () => {
    setOpen((current) => !current)
  }

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <Tooltip
        {...props}
        PopperProps={{
          disablePortal: true,
        }}
        onClose={handleTooltipClose}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
      >
        {cloneElement(children, {
          onClick: handleTooltipToggle,
          onMouseEnter: handleTooltipOpen,
          onMouseLeave: handleTooltipClose,
        })}
      </Tooltip>
    </ClickAwayListener>
  )
}

GofindTooltip.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top',
  ]),
  children: PropTypes.element.isRequired,
}

GofindTooltip.defaultProps = {
  title: '',
  placement: 'bottom',
}

export default GofindTooltip
